export const LANGUAGES = {
  en: 'en',
  no: 'nb',
  nb: 'nb',
  sv: 'sv',
  da: 'da',
};
export const DEFAULT_LANGUAGE = LANGUAGES.en;
